module.exports = "/_next/static/images/WantToRetainCustomers-xs-53f1669c846a6b3230316fd6bdc73acc.webp";